module.exports = __webpack_public_path__ + "img/newsletter_jobmule.98e73468.png";